import { FC, useCallback, useState } from 'react'
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'
import './email.css'

// COMPONENTS
import Toast, { IToast } from '@components/molecules/toast'

// ROUTES
import { AddEmailRoute } from './add'
import { EmailIdRoute } from './[emailId]'

// TYPES
import type { RouteObject } from 'react-router-dom'


type ProfileEmailContext = { setToast: (toast: IToast | undefined) => void }
export const useProfileEmailContext = () => useOutletContext<ProfileEmailContext>()

const Component: FC<{}> = () => {
    const navigate = useNavigate()
    const [toast, setT] = useState<IToast>()
    const setToast = useCallback((toast: IToast | undefined) => { setT(toast) }, [setT])

    function handleBack() {
        navigate(-1)
    }

    return (<>
        <a onClick={handleBack}>
            <img src="/icons/arrow-left.svg" alt="back" style={{ width: '1.4rem', height: '1.4rem' }} draggable="false" />
        </a>
        <div className="temp-card">
            <Outlet context={{ setToast } satisfies ProfileEmailContext} />
        </div>
        <Toast toast={toast} />
    </>)
}

const EmailRoute: RouteObject = {
    path: "email",
    Component,
    children: [
        AddEmailRoute,
        EmailIdRoute,
    ]
}

export { EmailRoute }
